import validator from 'email-validator';

class EmailValidatorAdapter {
  isValid (email) {
    return validator.validate(email);
  }
}

export default EmailValidatorAdapter;
